import React from 'react';
import GlobalTaxAdvisoryView from "./GlobalTaxAdvisoryView"
function GlobalTaxAdvisory(props) {
    return (
        <GlobalTaxAdvisoryView/>
        );
}

export default GlobalTaxAdvisory;
